import {Component, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {IonSlides, ModalController} from '@ionic/angular';


@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})

export class AboutUsComponent {
  @ViewChild('slides', {static: true}) slider: IonSlides;
  segment = 0;

  constructor(public router: Router,
              public modalController: ModalController) {
  }

  async segmentChanged(ev: any) {
    await this.slider.slideTo(this.segment);
  }

  async slideChanged() {
    this.segment = await this.slider.getActiveIndex();
  }

  dismiss(): void {
    this.modalController.dismiss();
  }

  navigateToIC() {
    window.open('http://www.invisiblecity.org.au/', '_blank');
  }

  navigateToResilientResearch() {
    window.open('https://www.westernsydney.edu.au/young-and-resilient', '_blank');
  }
}
